var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDossierBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000101075051941135327850000015217015216865825412_);}\n\t.st2{clip-path:url(#SVGID_00000142177550695238724480000002326444600101985682_);}\n\t.st3{clip-path:url(#SVGID_00000034805083320655902310000002109047055769956271_);fill:#55BBB1;}\n\t.st4{clip-path:url(#SVGID_00000061445900611403622380000007290043424209244094_);}\n\t.st5{clip-path:url(#SVGID_00000027571547959969865580000005661787157912924804_);fill:#55BBB1;}\n\t.st6{clip-path:url(#SVGID_00000028301480147110339210000008179816642193276061_);}\n\t.st7{clip-path:url(#SVGID_00000018954285284039182840000016409144371006110369_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 18.7,
    y: 129.9,
    width: 754,
    height: 305.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147195128443061156930000001474120524953109660_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147195128443061156930000001474120524953109660_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 793,
    height: 321,
    xlinkHref: "F4F5D9880351DE07.png",
    transform: "matrix(0.9508 0 0 0.9508 18.665 129.929)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070113680386310465740000016009134569341548709_",
    x: 28.2,
    y: 139.4,
    width: 735,
    height: 286.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049187952008429039870000005461111922874076829_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070113680386310465740000016009134569341548709_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049187952008429039870000005461111922874076829_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158027357516492174230000014004896990033897867_",
    d: "M751.6,189.1l0.4,0.4v0.6v209.6v0.8l-0.6,0.4 L729,415.3l-0.3,0.2l-0.3,0l-666.5,0.1h-0.5l-0.4-0.4l-22.4-24l-0.4-0.4v-0.6l0.1-238.9l0-1.3l1.2,0l614.9-0.2h0.5l0.4,0.4 l16.1,17.9l59,0h0.5l0.4,0.4L751.6,189.1z M730,170.8l-59,0h-0.5l-0.4-0.4L654,152.5l-613.2,0.2l-0.1,237l21.6,23.3l665.6-0.1 l21.5-13.9V190.6L730,170.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169555834574219429690000011425202108518817468_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158027357516492174230000014004896990033897867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000169555834574219429690000011425202108518817468_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000092442737738571004540000002941758223513155225_",
    x: 18.7,
    y: 129.9,
    width: 753,
    height: 305.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114032776769199950620000002936365936597635214_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092442737738571004540000002941758223513155225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 148.9,
    style: {
      clipPath: "url(#SVGID_00000114032776769199950620000002936365936597635214_)",
      fill: "#55BBB1"
    },
    width: 715.6,
    height: 267.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049187952008429039870000005461111922874076829_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041295260222052255830000015553788057125754536_",
    d: "M710.3,422.4H79h-0.6v0.7v1.4v0.7H79h631.4h0.6v-0.7 v-1.4v-0.7H710.3z M761.5,391.2h-1.3h-0.6v0.7l0,14.3l-25.1,16.3h-13.3h-0.6v0.7v1.4v0.7h0.6h13.6h0.2h0.2l0.1-0.1l0.2-0.1 l26-16.9l0.3-0.2l0.3-0.2v-0.4l0-0.4l0-15v-0.7H761.5z M30.1,382.1h-1.3h-0.6v0.7v13.1v0.3v0.3l0.2,0.2l0.2,0.2l26,28l0.2,0.2 l0.2,0.2h0.3h0.3h12.2h0.6v-0.7v-1.4v-0.7h-0.6H55.9l-25.2-27.2v-12.5v-0.7H30.1z M30.1,161.7h-1.3h-0.6v0.7v210.5v0.7h0.6h1.3 h0.6v-0.7V162.3v-0.7H30.1z M735.1,159.3h-0.3h-12.9h-0.6v0.7v1.4v0.7h0.6h12.4l25.2,25.3l0,12.4l0,0.7h0.6h1.3h0.6v-0.7l0-13 v-0.3l0-0.3l-0.2-0.2l-0.2-0.2l-26-26.1l-0.2-0.2l-0.2-0.2H735.1z M632.3,140.1H51h-0.6v0.7v1.4v0.7H51h581.3h0.6v-0.7v-1.4 v-0.7H632.3z M658.3,140.1H658h-15.7h-0.6v0.7v1.4v0.7h0.6h15.2l16.9,18.8l0.2,0.2l0.2,0.2h0.3h0.3h9.6h0.6v-0.7V160v-0.7h-0.6 h-9l-16.9-18.8l-0.2-0.2l-0.2-0.2H658.3z M28.2,139.9v0.7v0.7v13v0.7h0.6h1.3h0.6v-0.7v-11.7h10.7h0.6V142v-1.4v-0.7H28.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104675755883883136060000011036122823076260523_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041295260222052255830000015553788057125754536_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104675755883883136060000011036122823076260523_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165231136705592468560000004295582973892767156_",
    x: 18.7,
    y: 129.9,
    width: 753,
    height: 305.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171702622751444615330000014796465669216817596_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165231136705592468560000004295582973892767156_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 139,
    style: {
      clipPath: "url(#SVGID_00000171702622751444615330000014796465669216817596_)",
      fill: "#55BBB1"
    },
    width: 735.9,
    height: 287.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049187952008429039870000005461111922874076829_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000157996564442947858230000004689871108173388681_",
    points: "761.3,209.1 760.2,209.1 759.7,209.1  759.7,209.7 759.7,381.5 759.7,382.1 760.2,382.1 761.3,382.1 761.8,382.1 761.8,381.5 761.8,209.7 761.8,209.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119098523373991942760000011844883532498321302_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157996564442947858230000004689871108173388681_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119098523373991942760000011844883532498321302_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106848128945403198190000003270891959609746819_",
    x: 18.7,
    y: 129.9,
    width: 753,
    height: 305.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128465135899782695570000006237923672981553557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106848128945403198190000003270891959609746819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 758.8,
    y: 208.2,
    style: {
      clipPath: "url(#SVGID_00000128465135899782695570000006237923672981553557_)",
      fill: "#55BBB1"
    },
    width: 4,
    height: 174.8
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossierBorder);
export default __webpack_public_path__ + "static/media/dossier-border.71b6418525f8ccb9c3da0d400d1e754e.svg";
export { ForwardRef as ReactComponent };